import { NavLink, Outlet } from "react-router-dom";

const ResourcesTab = () => {
  return (
    <>
      <nav>
        <NavLink to="/"></NavLink>
      </nav>
      <main>
        <Outlet />
      </main>
    </>
  );
};

export default ResourcesTab;
